import {
    supportConstants,
    catalogSearchConstants,
    catalogInlineSearchConstants,
    postRequestAPIConstants,
    apidocsFromElasticConstants,
    providersFromAPIConstants,
    getIntentProvidersConstants,
    getIntentLanguagesConstants,
    getNewsConstants,
} from '../constants'
import services from '../services'
import { track } from '../../../utils'

export function supportSendMessageAction(data) {
    return async dispatch => {
        dispatch(request())

        return services.support(data).then(
            result => {
                dispatch(success(result))
            },
            error => {
                dispatch(failure(error))
            }
        )
    }

    function request() {
        track('support request', {})
        return { type: supportConstants.REQUEST }
    }
    function success(data) {
        track('support success', {})
        return { type: supportConstants.SUCCESS, data }
    }
    function failure(error) {
        track('support failure', {
            reason: error,
        })
        return { type: supportConstants.FAILURE, error }
    }
}

export function supportResetFormAction() {
    return async dispatch => {
        const res = dispatch(request())
        return res
    }

    function request() {
        return { type: supportConstants.RESET }
    }
}

export function supportResetStatusAction() {
    return async dispatch => {
        const res = dispatch(request())
        return res
    }

    function request() {
        return { type: supportConstants.RESET_STATUS }
    }
}

export function apidocsFromElasticAction(data) {
    const { slug } = data
    return async (dispatch, apidocsFromElastic) => {
        const cached = apidocsFromElastic[slug]
        if (cached) {
            return dispatch(success(cached, true))
        }
        dispatch(request())

        return services.apidocsFromElastic(data).then(
            result => dispatch(success(result)),
            error => dispatch(failure(error))
        )
    }

    function request() {
        track('apidocsFromElastic request', {})
        return { type: apidocsFromElasticConstants.REQUEST, slug }
    }
    function success(response, silenced = false) {
        if (!silenced) {
            track('apidocsFromElastic success', {})
        }
        return { type: apidocsFromElasticConstants.SUCCESS, response, slug }
    }
    function failure(error) {
        track('apidocsFromElastic failure', {
            reason: error,
            slug,
        })
        return { type: apidocsFromElasticConstants.FAILURE, error, slug }
    }
}

export function providersFromAPIAction({ providers: data, slug }) {
    return async dispatch => {
        dispatch(request())

        return services.providersFromAPI(data).then(
            result => dispatch(success(result)),
            error => dispatch(failure(error))
        )
    }

    function request() {
        track('providersFromAPI request', { slug })
        return { type: providersFromAPIConstants.REQUEST, slug }
    }
    function success(response) {
        track('providersFromAPI success', { slug })
        return { type: providersFromAPIConstants.SUCCESS, response, slug }
    }
    function failure(error) {
        track('providersFromAPI failure', {
            reason: error,
            slug,
        })
        return { type: providersFromAPIConstants.FAILURE, error, slug }
    }
}

function trackFailure(event, params, error) {
    const { response = {} } = error
    const { data = {}, status, statusText } = response
    const { message } = data

    if (message) {
        params.message = message
    } else {
        params.message = error
    }
    track(event, { ...params, status, statusText })
}

export function getIntentProvidersAction(slug) {
    return async dispatch => {
        dispatch(request())

        return services.getIntentProviders(slug).then(
            result => dispatch(success(result)),
            error => dispatch(failure(error))
        )
    }

    function request() {
        return { type: getIntentProvidersConstants.REQUEST, slug }
    }
    function success(response) {
        if (Array.isArray(response)) {
            return { type: getIntentProvidersConstants.SUCCESS, response, slug }
        }
        const params = {
            request: 'getIntentProviders',
            message: 'success with unexpected data type',
            slug,
        }
        trackFailure('API failure', params, response)

        return {
            type: getIntentProvidersConstants.FAILURE,
            error: response,
            slug,
        }
    }
    function failure(error) {
        const params = {
            request: 'getIntentProviders',
            slug,
        }

        trackFailure('API failure', params, error)

        return { type: getIntentProvidersConstants.FAILURE, error, slug }
    }
}

export function getIntentLanguagesAction(slug) {
    return async dispatch => {
        dispatch(request())

        return services.getIntentLanguages(slug).then(
            result => dispatch(success(result)),
            error => dispatch(failure(error))
        )
    }

    function request() {
        return { type: getIntentLanguagesConstants.REQUEST, slug }
    }
    function success(response) {
        return { type: getIntentLanguagesConstants.SUCCESS, response, slug }
    }
    function failure(error) {
        const params = {
            request: 'getIntentLanguages',
            slug,
        }

        trackFailure('API failure', params, error)

        return { type: getIntentLanguagesConstants.FAILURE, error, slug }
    }
}

export function catalogSearchParamsAction(params) {
    return { type: catalogSearchConstants.CHANGE, params }
}

export function catalogInlineSearchParamsAction(params) {
    return { type: catalogInlineSearchConstants.CHANGE, params }
}

export function resetSearchParamsAction() {
    return { type: catalogSearchConstants.RESET }
}
export function resetDemoParamsOnInputChange(params) {
    return { type: postRequestAPIConstants.RESET, data: params }
}

function requiresCustomAuth(data = {}) {
    const { provider = {}, keychain = {} } = data
    const { token } = keychain

    if (!token) {
        // all requests return cached result anyway
        return false
    }

    if (!provider.integrated) {
        // not integrated providers will not work for any key - sandbox or production
        return true
    }

    if (!provider.billable) {
        // if integrated but not billable -- probable means that such a provider requires own keys (a lot of examples for the sentiment intent) - sandbox or production
        return true
    }

    if (!provider.stock_model) {
        // providers without a stock model require a custom model for sure
        return true
    }
    // maybe provider.own_auth is important for this

    return false
}

export function isPremium(data = {}) {
    const { provider = {}, keychain = {} } = data
    const { token, production } = keychain
    if (production) {
        // all requests are paid by the user
        return false
    }
    if (!token) {
        // all requests return cached result
        return false
    }

    // modern MT is too expensive for the sandbox trial mode
    return (
        provider.api_id === 'modernmt' || provider.api_id === 'modernmtrealtime'
    )
}

export function postRequestAPIAction(data = {}) {
    return async dispatch => {
        dispatch(request())
        if (isPremium(data) || requiresCustomAuth(data)) {
            const result = {
                response: {
                    error: {
                        code: 413,
                        message:
                            'We do not route requests to these providers yet.',
                    },
                },
            }
            return dispatch(failure(result))
        }
        try {
            const response = await services.postRequestAPI(data)
            return dispatch(success(response))
        } catch (error) {
            return dispatch(failure(error))
        }
    }

    function request() {
        track('postRequestAPI request', {
            slug: data.slug,
        })
        return { type: postRequestAPIConstants.REQUEST, data }
    }
    function success(response) {
        track('postRequestAPI success', {
            slug: data.slug,
        })
        return { type: postRequestAPIConstants.SUCCESS, data, response }
    }
    function failure(error) {
        track('postRequestAPI failure', {
            reason: error,
            slug: data.slug,
        })

        const params = {
            request: 'postRequestAPI',
            slug: data.slug,
        }

        trackFailure('API failure', params, error)

        return { type: postRequestAPIConstants.FAILURE, data, error }
    }
}

export function getNews() {
    return async dispatch => {
        dispatch(request())
        try {
            const response = await services.getNews()
            return dispatch(success(response))
        } catch (error) {
            return dispatch(failure(error))
        }
    }

    function request() {
        track('Medium API request request', {
            slug: 'medium news',
        })
        return { type: getNewsConstants.REQUEST }
    }
    function success(response) {
        track('Medium API request success', {
            slug: 'medium news',
        })
        return { type: getNewsConstants.SUCCESS, response }
    }
    function failure(error) {
        track('Medium API request failure', {
            reason: error,
            slug: 'medium news',
        })

        const params = {
            request: 'Medium API request',
            slug: 'medium news',
        }

        trackFailure('API failure', params, error)

        return { type: getNewsConstants.FAILURE, error }
    }
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/actions/index.js